<template>
  <div class="login-container">
    <!--    <img src="../assets/Logo-icon.png" alt="" class="Logo-icon">-->
    <div class="login-wrapper">
      <div class="form-title">欢迎登录教师资格管理信息系统</div>
      <p
        style="height: 44px;font-size: 40px;font-family: HelveticaNeueLT;font-weight: 100;color: #2571E3;line-height: 46px;opacity: 0.3;text-align: center"
      >
        welcome
      </p>
      <a-form-model
        :model="form"
        :rules="rules"
        ref="loginForm"
        @submit.native.prevent
      >
        <!--          @submit="handleSubmit"-->
        <a-form-model-item v-if="ukey">
          <a-input
            :disabled="ukey"
            v-model="form.orgName"
            class="Account"
            size="large"
            style="border-radius: 50%"
          >
            <a-icon slot="prefix" type="user" />
          </a-input>
        </a-form-model-item>

        <a-form-model-item prop="account">
          <a-input
            :disabled="ukey"
            v-model="form.account"
            placeholder="请输入用户名"
            class="Account"
            size="large"
            style="border-radius: 50%"
          >
            <a-icon slot="prefix" type="user" />
          </a-input>
        </a-form-model-item>
        <a-form-model-item prop="pass">
          <a-input-password
            v-model="form.pass"
            placeholder="请输入密码"
            size="large"
          >
            <a-icon slot="prefix" type="lock" />
<!--            <component :is="elIcons" slot="suffix" theme="outline" size="20" fill="#333"  @click="flags=!flags"/>-->
          </a-input-password>
        </a-form-model-item>
        <!--          <a-form-model-item prop="offset">-->
        <!--            <drag-captcha v-model="form.offset" @set-offset-x="getCaptchaInfo" message="验证码通过"/>-->
        <!--          </a-form-model-item>-->
        <a-form-model-item class="no-style">
          <a-button
            type="primary"
            shape="round"
            html-type="submit"
            size="large"
            @click="handleSubmit"
          >
            登录
          </a-button>

          <a-row :gutter="24">
            <a-col :span="12"> </a-col>
            <a-col :span="12" align="right">
              <router-link to="/findPassword">忘记密码</router-link>
            </a-col>
          </a-row>
        </a-form-model-item>

        <!--          <a-row :gutter="24">-->
        <!--            <a-col :span="12">-->

        <!--            </a-col>-->
        <!--            <a-col :span="12" align="right">-->
        <!--              <router-link to="/findPassword">忘记密码</router-link>-->
        <!--            </a-col>-->
        <!--          </a-row>-->
      </a-form-model>
    </div>

    <!--      <use-modal-->
    <!--        :modal-visible="modalVisible"-->
    <!--        :modal-title="modalTitle"-->
    <!--        :modal-width="400"-->
    <!--        @handle-cancel="modalCancel"-->
    <!--        @handle-ok="modalSubmit"-->
    <!--      >-->
    <!--        <sms-code :user-info="userInfo" />-->
    <!--      </use-modal>-->

    <use-modal
      :dis-block="true"
      :modal-visible="modalVisible"
      :modal-title="modalTitle"
      :modal-width="500"
      @handleCancel="modalCancel"
      @handleOk="modalSubmit"
    >
      <sms-code :user-info="userInfo" />
    </use-modal>

    <mod-password
      ref="modPassword"
      :modal-show="modalShowVisable"
      :modal-pass-title="modaPasslTitle"
      :passloading="passloading"
      :modal-pass-width="700"
      @handlePassOk="handlePassOk"
      @handlePassCancel="handlePassCanceled"
      :form-val="passform"
    >
    </mod-password>

  </div>
</template>
<script>
// @ is an alias to /src
import CONFIG from "@/index";
import { mapActions } from "vuex";
import UseModal from "@/components/UseModal.vue";
import SmsCode from "@/components/SmsCode.vue";
import hexMd5 from "js-md5";
import ModPassword from "../components/ModPassword.vue";

export default {
  name: "Login",
  components: {
    ModPassword,
    UseModal,
    SmsCode
  },
  mounted() {
    //读取证书信息
    this.$json("getUKeyCert", {}).then(res => {
      if (res.account && res.account !== "null") {
        this.form.account = res.account;
        this.form.orgName = res.orgName;
        this.ukey = true;
        if (res.isOldKey && res.isOldKey !== "1") {
          sessionStorage.setItem("uk", "1");
        }

      } else {
        sessionStorage.removeItem("uk");
      }
    });
  },
  data() {
    return {
      flags:false,

      modalShowVisable: false,
      passloading: false,
      modaPasslTitle: "修改密码",
      IsmodifyMyPassword: true,
      passform: {},
      salt: "",

      ukey: false,
      form: {
        account: "",
        orgName: "",
        pass: ""
      },
      modalVisible: false,
      modalTitle: "登录保护",
      userInfo: { mobile: "", hash: "1" },
      rules: {
        account: [
          {
            required: true,
            message: "用户名不能为空",
            trigger: ["blur", "change"]
          }
          // {validator: this.userNameValidate, trigger: ["blur"]}
        ],
        pass: [{ required: true, message: "密码不能为空", trigger: "blur" }]
        // offset: [{ required: true, message: "请先完成拼图验证", trigger: "change" }]
      }
    };
  },
  computed: {
    type() {
      return this.flags ? 'text' : 'password'
    },
    elIcons() {
      return this.flags ? 'svg-preview-open' : 'svg-preview-close-one'
    }
  },

  methods: {
    ...mapActions(["GenerateRoutes", "setPermissionbtn"]),
    modalCancel() {
      this.modalVisible = false;
    },
    modalSubmit(form) {
      form.$refs.smsCodeForm.validate(valid => {
        if (valid) {
          const params = {
            userName: this.userInfo.userName,
            token: this.userInfo.smsToken,
            code: form.form["code"]
          };
          this.$json("checkLoginSms", params).then(res => {
            if (res.code) {
              var msg="如该手机号码有误或无法获取验证码，请联系您的上级部门进行修改。";
              this.$message.error(res.message + msg );
            } else {
              //通过验证
              sessionStorage.setItem("key", sessionStorage.getItem("Akey"));
              sessionStorage.setItem(
                "unInfo",
                sessionStorage.getItem("AunInfo")
              );
              sessionStorage.setItem("salt", sessionStorage.getItem("Asalt"));

              if (sessionStorage.getItem("orgType") == 1) {

                const userInfo= JSON.parse(sessionStorage.getItem("unInfo"))
                const orgId= userInfo.user.orgId;
                const params = {
                  url: "viewBaseOrgBasic",
                  query: {
                    id: orgId
                  }
                };

                this.$json(params.url, params.query)
                  .then(response => {

                    if (response.orgBizType == 1 || response.orgBizType == 3) {
                      this.$router.push({ path: "/register/OrgViewOrgBatchSubModel" });
                    } else {
                      this.$router.push({ path: "/enrollModel/OrgBatchCitySubModel" });
                      // this.$router.push({ path: "/enrollModel/OrgViewOrgBatchSubModel" });
                    }

                  })
                  .catch(e => {
                    this.$message.error(e.message);
                  });

                // this.$router.push("./HomeWorks/confirmaIndex");
              } else {
                if(sessionStorage.getItem("orgType") == 6){
                  this.$router.push({ path: "/auditorExamptionConfirm/filingsManage/normalEduAbilityAssess" });
                }else{
                  this.$router.push("./HomeWorks");
                }
              }
              this.modalVisible = false;
            }
          });
        }
      });
    },

    userNameValidate(rule, value, callback) {
      if (this.getLength(this.form["account"]) > 14) {
        callback(new Error("用户名信息超过长度，请重新填写！"));
      } else {
        callback();
      }
    },
    getLength(str) {
      ///获得字符串实际长度，中文2，英文1
      let realLength = 0;
      const len = str.length;
      let charCode = -1;

      for (let i = 0; i < len; i++) {
        charCode = str.charCodeAt(i);

        if (charCode >= 0 && charCode <= 128) realLength += 1;
        else realLength += 2;
      }
      return realLength;
    },
    handleSubmit(e) {
      // e.preventDefault();
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          const uri = "login";
          let salt = Math.random()
            .toString(36)
            .substr(2);
          if(salt.length >10){
            this.salt = salt.substr(0,9);
          }else{
            this.salt = salt;
          }
          const params = {
            account: this.form.account,
            pass: this.form.pass,
            salt: this.salt,
            type: 1
          };
          this.$json(uri, params)
            .then(response => {
              // response.user.superuser=1
              sessionStorage.setItem("Akey", this.form.account);
              sessionStorage.setItem("AunInfo", JSON.stringify(response));
              sessionStorage.setItem("Asalt", JSON.stringify(this.salt));
              sessionStorage.setItem("Akey", JSON.stringify(this.form.account));
              sessionStorage.setItem("orgType", response.user.orgType);

              if (
                response.user.loginType == "sms" ||
                response.user.loginType == "certsms"
              ) {
                this.userInfo.mobile = response.user.phone;
                this.userInfo.smsToken = response.user.smsToken;
                this.userInfo.userName = this.form["account"];
                this.modalVisible = true;
                return;
              }

              sessionStorage.setItem("key", this.form.account);
              sessionStorage.setItem("unInfo", JSON.stringify(response));
              sessionStorage.setItem("salt", JSON.stringify(this.salt));
              sessionStorage.setItem("key", JSON.stringify(this.form.account));

              // this.$router.push("/model2/model2Sub");
              if (response.privilege) {
                // this.CtrlButton(response.privilege.button);
                this.GenerateRoutes(response.privilege.menu);
              } else {
                this.GenerateRoutes([]);
              }

              //判断是否需要强制修改密码
              if (response.user.passOverdue == 1) {
                this.$message.warn("密码已过期，请修改密码后重新登陆！");
                sessionStorage.clear();
                sessionStorage.setItem("unInfo2", JSON.stringify(response));
                sessionStorage.setItem("salt2", JSON.stringify(this.salt));
                sessionStorage.setItem("key2", JSON.stringify(this.form.account));
                this.modalShowVisable = true;
                return;
              }

              if (response.user.orgType == 1) {
                // this.$router.push({ path: "confirmaIndex" });

                let userInfo= JSON.parse(sessionStorage.getItem("unInfo"))
                let orgId= userInfo.user.orgId;
                const params = {
                  url: "viewBaseOrgBasic",
                  query: {
                    id: orgId
                  }
                };
                this.$json(params.url, params.query)
                  .then(response => {

                    if (response.orgBizType == 1) {
                      this.$router.push({ path: "/register/OrgViewOrgBatchSubModel" });
                    } else {
                      this.$router.push({ path: "/enrollModel/OrgBatchCitySubModel" });
                      // this.$router.push({ path: "/enrollModel/OrgViewOrgBatchSubModel" });
                    }



                  })
                  .catch(e => {
                    this.$message.error(e.message);
                  });

              } else {
                if(sessionStorage.getItem("orgType") == 6){
                  this.$router.push({ path: "/auditorExamptionConfirm/filingsManage/normalEduAbilityAssess" });
                }else{
                  this.$router.push("./HomeWorks");
                }
                // this.$router.push("./HomeWorks");
              }
            })
            .catch(e => {
              this.$message.error(e.message);
            });
        }
      });
    },

    handlePassCanceled(ref) {
      this.passform = {};
      ref.resetFields();
      this.modalShowVisable = false;
    },
    handlePassOk(e) {
      const session = JSON.parse(sessionStorage.getItem("unInfo2"));
      this.key3 = session.key;
      e.validate(valid => {
        if (valid) {
          const uri = "personalPassword";
          let account = JSON.parse(sessionStorage.getItem("key2"));
          // 加密密码
          const oldPwd = hexMd5(
            `${account}${hexMd5(this.passform["oldPassword"])}`
          );

          console.info("key3===" + this.key3);

          const params = {};
          console.info("oldPwd1===" + oldPwd);

          params.oldPwd = this.des3Encrypt(this.key3, oldPwd);

          console.info("oldPwd2===" + params.oldPwd);

          const newPwd = hexMd5(
            `${account}${hexMd5(this.passform["password"])}`
          );
          params.newPwd = this.des3Encrypt(this.key3, newPwd);
          this.$json(uri, params)
            .then(response => {
              // this.$router.push("/Login");
              this.$message.success("修改密码成功");
              this.showModifyPassword = false;
              this.modalShowVisable = false;
              setTimeout(() => {
                location.reload();
              }, 1000);
            })
            .catch(e => {
              this.$message.error(e.message);
            });
        } else {
          return false;
        }
      });
    },

  }
};
</script>

<style lang="less" scoped>
.login-container {
  height: 100%;
  background: url("../assets/Login-banner.png") no-repeat;
  background-size: 100% 100%;

  .Logo-icon {
    width: 400px;
    height: 400px;
    position: absolute;
    top: 50%;
    left: 350px;

    transform: translateY(-50%);
    margin: 0 auto;
  }

  .login-wrapper {
    width: 420px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -220px;
    margin-top: -175px;
    //margin: 0 auto;
    padding: 20px;
    border-radius: 4px;
    //box-shadow: 0 0 8px #ccc;
    //background-color: rgba(255, 255, 255, 0.5);
    //transform: translateY(-50%);

    .form-title {
      margin-bottom: 15px;
      font-size: 24px;
      text-align: center;
      font-family: PangMenZhengDao;
      font-weight: bold;
      color: #043876;
    }

    /deep/ .ant-input {
      //background-color: #ebeef3;
      background: rgba(255, 255, 255, 0.5);
      border: 1px solid #a9c1db;
      border-radius: 30px;
    }

    .no-style {
      margin-bottom: 10px;

      .ant-btn {
        width: 100%;
      }
    }

    /deep/ .safe-code {
      .ant-form-item-children {
        display: flex;

        .ant-input-affix-wrapper {
          margin-right: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue